// extracted by mini-css-extract-plugin
module.exports = {"editProjectIcon":"EditProjectIcon_editProjectIcon_1Blgd","icon":"EditProjectIcon_icon_3AVWe"};